import { useMemo } from 'react';

const useHasMore = (count?: number, page?: number, pageSize?: number): boolean => {
  count = count || 0;
  page = page || 1;
  pageSize = pageSize || 10;
  return useMemo(() => count > 0 && page * pageSize < count, [count, page, pageSize]);
};
export default useHasMore;
